import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es música original o covers?',
  a: 'Principalmente covers en vivo, interpretados con respeto y calidad.'
}, {
  q: '¿Cada cuánto suben contenido?',
  a: 'Publicamos de forma constante; suscribite para enterarte apenas salga una nueva sesión.'
}, {
  q: '¿Desde dónde se puede ver?',
  a: 'Desde cualquier país. Hay comunidad en Latinoamérica, España y Estados Unidos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <h2 className="text-3xl md:text-5xl font-serif mb-12 text-center" data-id="element-11">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-12">
          {faqs.map((faq, idx) => <div key={idx} className="bg-surface border border-white/5 rounded-2xl overflow-hidden" data-id="element-13">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-14">
                <span className="text-lg font-medium pr-8" data-id="element-15">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-amber-500 shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-16" />
              </button>

              <AnimatePresence data-id="element-17">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-18">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-19">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}